// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    orderChangeState: state.greif.pages.orderChange,
});

export interface OrderDetailsHeaderProps extends WidgetProps {}

export interface OrderDetailsHeaderStyles {}

export const orderDetailsHeaderStyles: OrderDetailsHeaderStyles = {};

const styles = orderDetailsHeaderStyles;

type Props = OrderDetailsHeaderProps & ReturnType<typeof mapStateToProps>;

const ReviewRequestOrderChangeHeader: FC<Props> = ({ id, orderChangeState }) => {
    const { requestSubmitted } = orderChangeState;
    const { value: order } = useContext(OrderStateContext);
    const currentPage = useCurrentPage();
    const linkBack = usePageLinkByPageType(constants.pageType.orderChangeRequest);

    return (
        <OrderHeader
            title={currentPage.fields.title}
            linkBack={requestSubmitted ? undefined : linkBack}
            pageIdSegment={
                requestSubmitted ? `?orderNumber=${order?.webOrderNumber || order?.erpOrderNumber}` : undefined
            }
        >
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ReviewRequestOrderChangeHeader),
    definition: {
        group: constants.widgetGroup.reviewOrderChangeRequest,
        displayName: "Review Order Change Request Header",
        allowedContexts: ["ReviewOrderChangeRequestPage" as any],
    },
};

export default widgetModule;
